import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const CATEGORIES = ["Resin Art", "Macramé", "Ceramics & Pottery", "Candles & Fragrance"];

export default function Footer() {
  return (
    <footer className="border-t border-line bg-parchment" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-12 md:px-8 md:py-20">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-stone2">
            Hand-poured resin, hand-knotted macramé and small-batch ceramics &amp; candles — made
            slowly at the studio bench and shipped across India.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="label-mono">Shop</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c}>
                <Link
                  to={`/shop?category=${encodeURIComponent(c)}`}
                  className="transition-colors hover:text-terracotta"
                  data-testid={`footer-category-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  {c}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/shop" className="font-semibold transition-colors hover:text-terracotta" data-testid="footer-shop-all">
                Everything
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="label-mono">Studio</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <a href="mailto:hello@knotandcast.in" className="transition-colors hover:text-terracotta" data-testid="footer-email-link">
                hello@knotandcast.in
              </a>
            </li>
            <li>
              <a href="/#gifting" className="transition-colors hover:text-terracotta" data-testid="footer-gifting-link">
                Custom designs, return gifts &amp; bulk orders
              </a>
            </li>
            <li>
              <Link to="/admin" className="transition-colors hover:text-terracotta" data-testid="footer-admin-link">
                Owner login
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-6 font-mono text-[11px] uppercase tracking-[0.15em] text-stone-400 md:px-8">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Knot &amp; Cast</span>
          <span>Handmade in India</span>
        </div>
      </div>
    </footer>
  );
}
